import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { PropertyService } from '@app/_components/property';
import { VrboService } from '@app/_services/vrbo.service';

@Component({
    selector: 'app-vrbo-availability',
    templateUrl: './vrbo-availability.component.html',
    styleUrls: ['./vrbo-availability.component.css'],
    standalone: false
})
export class VRBOAvailabilityComponent implements OnInit {
  form1!: UntypedFormGroup;
  formLoading = false;
  shortTermRentals: any[] = [];

  validationMessages = {
    shortTermRentalId: [{ type: 'required', message: 'Property is required' }]
  };

  constructor(
    private formBuilder: UntypedFormBuilder,
    private messageService: MessageService,
    private propertyService: PropertyService,
    private vrboService: VrboService
  ) {}

  ngOnInit(): void {
    this.buildForm();
    this.loadShortTermRentals();
  }

  buildForm(): void {
    this.form1 = this.formBuilder.group({
      shortTermRentalId: [null, Validators.required]
    });
  }

  loadShortTermRentals(): void {
    try {
      this.propertyService.findAllSummary()
        .subscribe(
          (res: any) => {
            this.shortTermRentals = res?.data?.properties || [];
          },
          (err: any) => {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: err?.message || 'Failed to load properties' });
          });
    } catch (error) {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: '' + error });
    }
  }

  onSyncUnitAvailability(): void {
    if (this.form1.invalid) {
      this.form1.markAllAsTouched();
      return;
    }
    const id = Number(this.form1.value.shortTermRentalId);
    this.formLoading = true;
    this.vrboService.syncUnitAvailabilityUpdate(id)
      .subscribe(
        (res: any) => {
          this.formLoading = false;
          this.messageService.add({ severity: 'success', summary: 'Saved', detail: '' + (res?.message || 'Availability sync triggered'), sticky: false });
        },
        (err: any) => {
          this.formLoading = false;
          this.messageService.add({ severity: 'error', summary: 'Failed', detail: 'We were unable to sync availability: ' + (err?.message || err), sticky: true });
        });
  }
}


